(() => {
  if (window.__ComponentRedeemSliderDefined) return;
  window.__ComponentRedeemSliderDefined = true;

  class ComponentRedeemSlider extends HTMLElement {
    constructor() {
      super();

      this.carousel = null;
      this.sliderWrapper = this.querySelector('.keen-slider-wrapper .keen-slider');

      this._initialized = false;
      this._buttonsBound = false;

      this.waitForLoyaltylion(this);
    }

    initCarousel() {
      if (this._initialized) return;
      this._initialized = true;

      if (!this.sliderWrapper) return;

      if (window.matchMedia("(max-width: 767px)").matches) {
        this.carousel = new KeenSlider(this.sliderWrapper, {
          arrows: this.querySelector('.keen-arrows'),
          navBar: this.querySelector('.keen-navbar'),
          mode: "snap",
          loop: false,
          autoplay: 0,
          dots: false,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          spacing: 20,
          breakpoints: {
            '(min-width: 901px)': { slidesPerView: 4 },
            '(min-width: 601px) and (max-width: 900px)': {
              spacing: 15,
              slidesPerView: 3
            },
            '(max-width: 600px)': {
              spacing: 10,
              slidesPerView: 2.5
            }
          }
        });

        document
          .querySelectorAll('.rewards-redeem-carousel .keen-slider-slide.hide')
          .forEach(item => item.classList.remove('hide'));

      } else {
        const sliderElement = this.sliderWrapper;
        sliderElement.classList.remove('keen-slider');
        sliderElement.classList.add('grid-view');
        sliderElement.classList.add('keen-slider');

        const viewMore = document.querySelector('.rewards-redeem-carousel button.trigger-more');
        if (viewMore && !viewMore.dataset.bound) {
          viewMore.dataset.bound = "true";
          viewMore.addEventListener('click', () => {
            viewMore.style.display = 'none';
            document
              .querySelectorAll('.rewards-redeem-carousel .keen-slider-slide.hide')
              .forEach(item => item.classList.remove('hide'));
          });
        }
      }
    }

    clickButton() {
      if (this._buttonsBound) return;
      this._buttonsBound = true;

      if (!this.sliderWrapper) return;

      this.sliderWrapper.querySelectorAll('[data-reward]').forEach(btn => {
        const rewardButton = this.closest('.main-content')
          ?.querySelector(`#loyaltylion [data-reward-id="${btn.dataset.reward}"] button`);

        if (!rewardButton) return;

        if (rewardButton.classList.contains('lion-action-button--disabled')) {
          btn.disabled = true;
          btn.innerHTML =
            rewardButton.textContent.toLowerCase() === 'paid items required'
              ? 'add items to cart to redeem'
              : rewardButton.textContent;
        } else {
          btn.disabled = false;
          btn.addEventListener('click', () => rewardButton.click(), { once: true });
        }
      });
    }

    waitForLoyaltylion(self) {
      let limitInterval = 10;

      const interval = setInterval(() => {
        if (self._initialized && self._buttonsBound) {
          clearInterval(interval);
          return;
        }

        const rewardReady = self.closest('.main-content')
          ?.querySelector('#loyaltylion .lion-rewards-list .lion-reward-item--product-cart button');

        if (rewardReady) {
          setTimeout(() => {
            self.clickButton();
            self.initCarousel();
          }, 2500);

          clearInterval(interval);
          return;
        }

        if (!limitInterval && self.querySelector('.keen-slider-wrapper')) {
          self.initCarousel();
          clearInterval(interval);
          return;
        }

        limitInterval--;
      }, 500);
    }
  }

  if (!customElements.get('redeem-slider')) {
    customElements.define('redeem-slider', ComponentRedeemSlider);
  }
})();
